import HeroAnimation from "./HeroAnimation.js";
import ProjectsAnimation from "./ProjectsAnimation.js";
import AboutAnimation from "./AboutAnimation.js";
import SkillsAnimation from "./SkillsAnimation.js";
import ProjectAnimation from "./ProjectAnimation.js";
import SubtitleAnimation from "./SubtitleAnimation.js";
import DefaultAnimation from "./DefaultAnimation.js";

export const animationMap = {
  hero: HeroAnimation,
  projects: ProjectsAnimation,
  lab: ProjectsAnimation,
  about: AboutAnimation,
  skills: SkillsAnimation,
  project: ProjectAnimation,
  subtitle: SubtitleAnimation,
  default: DefaultAnimation,
};
